export const environment = {
  production: true,
  mapBoxToken: 'pk.eyJ1IjoiY2VuZXJnb24iLCJhIjoiY2sxNG50MzF3MG1hMTNwdGtyY3A5MndmaCJ9.aEYmriTt0i7zYEV6nQVeTA',
  urlBackend: 'https://beneficios.signomedico.cipbyte.io/api/',
  urlOpenBlank: 'https://beneficios.signomedico.cipbyte.io/web/#/',
  urlOpenPagesHtml: 'https://beneficios.signomedico.cipbyte.io/#/web/assets/pages-html/',
  modoAdmin: false,
};

